/**
 * @fileoverview Taskflow Mobile Component
 * @author Qiwen Luo (qluo@yext.com)
 */

import {MultiStep, MultiStepProps} from '/ui/components/multistep/multistep';
import {LayoutHeaderMobile} from '/ui/components/taskflow/layoutHeaderMobile/layoutHeaderMobile';

import * as styles from '/ui/components/taskflow/taskflow.module.scss';

/**
 * @typedef {{
 *   headerLogo: React.ReactNode,
 *   multistep: MultiStepProps,
 *   pages: ?,
 *   CTAs: !Array<!React.ReactNode>,
 * }}
 */
let TaskflowMobileProps;

/**
* @param {TaskflowMobileProps} props
* @return {React.ReactElement}
*/
export function TaskflowMobile({
  headerLogo,
  multistep,
  pages,
  CTAs,
}) {
  const page = pages[multistep.selectedStepIndex];
  return (
    <div className={styles.compactLayout}>
      <div className={styles.navHeader}>
        {headerLogo}
        <div className={styles.partition}></div>
      </div>
      <div className={styles.stepper}>
        <MultiStep
          steps={multistep.steps}
          selectedStepIndex={multistep.selectedStepIndex}
          onChangeSelectedStepIndex={multistep.onChangeSelectedStepIndex}
          compactLayout={multistep.compactLayout}
          hasDropdown={multistep.hasDropdown}
        />
      </div>
      <LayoutHeaderMobile
        icon={page.icon}
        title={page.title}
        description={page.description}
        resourceLink={page.resourceLink}
        headerCTAs={page.headerCTA}
        contents={page.contents}
      />
      <div className={styles.ctas}>
        {CTAs}
      </div>
    </div>
  );
}
